<template>
	<div>
		<vxe-grid ref="fastreconciliation" v-if="list_gridOptions" v-bind="list_gridOptions"
			@toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	export default {
		mixins: [listMixins],
		props: {
			row: {
				default: () => {
					return {}
				}
			},
		},
		data() {
			return {
				list_footerField:[
					{field:'num',toFixed:0},
					{field:'diffamount',toFixed:2}
				]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			list_beforeCreateGrid(gridOptions) {
				gridOptions.height = 650
				gridOptions.toolbarConfig.buttons = [
					{
						name: '导出',
						status: 'success',
						code: 'export'
					},
					{
						name: '定位明细',
						status: 'primary',
						code: 'searchdetail'
					}
				]
				gridOptions.columns = [{
						type: 'checkbox',
						title: '#',
						width:50,
					},{
						type: 'seq',
						title: '#',
						width:50,
					},{
						field: 'importamount',
						title: '账单金额',
						sortable:true,
					},
					{
						field: 'settlementamount',
						title: '结算金额',
						sortable:true,
					},
					// {
					// 	field: 'importweight',
					// 	title: '账单重量',
					// 	sortable:true,
					// },
					// {
					// 	field: 'weight',
					// 	title: '结算重量',
					// 	sortable:true,
					// },
					{
						field: 'rangeimporttotalweight',
						title: '账单重量区间',
						sortable:true,
					},
					{
						field: 'rangetotalweight',
						title: '结算重量区间',
						sortable:true,
					},
					{
						field: 'num',
						title: '数量',
						sortable:true,
					},
					// {
					// 	field: 'diffweightavg',
					// 	title: '平均重量差异',
					// 	sortable:true,
						
					// },
					// {
					// 	field: 'diffweight',
					// 	title: '重量差异',
					// 	sortable:true,
					// },
					{
						field: 'diffamountavg',
						title: '平均金额差异',
						sortable:true,
						
					},
					{
						field: 'diffamount',
						title: '金额差异',
						sortable:true,
					},
					{
						title: '操作',
						fixed: "right",
						align: 'center',
						width: 130,
						slots: {
							default: ({row}) => {
								return [<el-button type = "text" size = "mini" onClick = {() => {this.searchdetail(row)}}>定位明细</el-button>]
							}
						}
					}
				]
				gridOptions.formConfig = false
			},
			list() {
				return new Promise((resolve) => {
					this.$api.expressreconciliation.fastreconciliation({
						billcode:this.row.code
					}).then((res)=>{
						resolve(res)
					})
				})
			},
			searchdetail(row = null){
				if(row){
					this.$emit('searchdetail',row)
				}else{
					let data = this.$refs.fastreconciliation.getCheckboxRecords()
					if(!data.length){
						this.$message.error('未选择数据')
						return
					}
					let num = this.$Lodash.sumBy(data, item => parseInt(item.num))
					if(num > 1000){
						this.$message.error('总数量不能大于1000')
						return
					}
					let expressNo = data.map((item)=>{
							return item.expressNo
						})
					this.$emit('searchdetail',{
						expressNo:expressNo.join('|')
					})
				}
				
			},
			submit() {
				//this.init()
			},
			reset() {
				//this.init()
			}
		},
		components: {

		}
	}
</script>